// extracted by mini-css-extract-plugin
module.exports = {"logout":"styles_logout__23XUQ"};